import multiguard from 'vue-router-multiguard';
import { checkAuth } from '@/router/_auth';
import { checkBankType } from '@/router/corporate/_type';
import { checkContractNo } from '@/router/corporate/_contract';

export default [{
	path: '/home/corporate/auto-attendance',
	name: 'corporateHome',
	redirect: { name: 'corporateContractSummary' },
	meta: {
		title: 'Bireysel Emeklilik',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/Home.vue'),
	children: [
		{
			path: 'contract-summary/:contract?',
			name: 'corporateContractSummary',
			meta: {
				title: 'Sözleşme Özeti',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/summary/Home.vue'),
		},
		{
			path: 'participant-transactions',
			name: 'corporateParticipantTransactions',
			redirect: { name: 'corporateTransactionAdd' },
			meta: {
				title: 'Katılımcı İşlemleri',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/transactions/Home.vue'),
			children: [
				{
					path: 'transaction-add',
					name: 'corporateTransactionAdd',
					meta: {
						title: 'Katılımcı Ekle',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/transactions/AddTransactions.vue'),
				},
				{
					path: 'file-list',
					name: 'corporateTransactionFileList',
					meta: {
						title: 'Dosya Yükleme Takibi',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/transactions/FileList.vue'),
				},
				{
					path: 'transaction-list/:file?',
					name: 'corporateTransactionList',
					meta: {
						title: 'Katılımcı Listesi',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/transactions/TransactionList.vue'),
				}
			]
		},
		{
			path: 'payment-transactions',
			name: 'corporatePaymentTransactions',
			redirect: { name: 'corporateSendCollection' },
			meta: {
				title: 'Ödeme İşlemleri',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/payment/Home.vue'),
			children: [
				{
					path: 'send-collection',
					name: 'corporateSendCollection',
					meta: {
						title: 'Tahsilat Gönderme',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/payment/SendCollection.vue'),
				},
				{
					path: 'file-list',
					name: 'corporatePaymentFileUpload',
					meta: {
						title: 'Dosya Yükleme Takibi',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/payment/FileList.vue'),
				},
				{
					path: 'payment-method',
					name: 'corporatePaymentMethod',
					meta: {
						title: 'Ödeme Yöntemi',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/payment/PaymentMethod.vue'),
				},
				{
					path: 'print-receipt',
					name: 'corporatePrintReceipt',
					meta: {
						title: 'Makbuz Bas',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/payment/PrintReceipt.vue'),
				},
			]
		},
		{
			path: 'contract-info',
			name: 'corporateContractInfo',
			meta: {
				title: 'Sözleşme Bilgileri',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/contract/Home.vue')
		},
		{
			path: 'users',
			name: 'corporateContractUsers',
			redirect: { name: 'corporateContractUserList' },
			meta: {
				title: 'Yetkili Kullanıcılar',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/users/Home.vue'),
			children: [
				{
					path: 'list',
					name: 'corporateContractUserList',
					meta: {
						title: 'Yetkili Kullanıcılar Listesi',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/users/List.vue')
				},
				{
					path: 'edit',
					name: 'corporateContractUserEdit',
					meta: {
						title: 'Kullanıcı Düzenle',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/users/Edit.vue')
				},
				{
					path: 'new',
					name: 'corporateContractUserNew',
					meta: {
						title: 'Yetkili Ekle',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/users/New.vue')
				},
			]
		},
	]
},
{
	path: '/home/corporate/auto-attendance/log/:tax/:contract',
	name: 'corporateHomeLog',
	meta: {
		title: 'Son 1 Aydaki Katılımcı Hareketleri',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType, checkContractNo]),
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/summary/HomeLog.vue')
},
{
	path: '/home/corporate/auto-attendance/all-contracts/:contract',
	name: 'corporateallContracts',
	meta: {
		title: 'Tüm Sözleşmeler',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType, checkContractNo]),
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/AllContract.vue')
},
{
	path: '/home/corporate/auto-attendance/participant-transactions/transaction-add/single/:contract',
	name: 'corporateAddSingleTransaction',
	meta: {
		title: 'Yeni Kişi Ekle',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType, checkContractNo]),
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/transactions/AddSingleTransaction.vue')
},
{
	path: '/home/corporate/auto-attendance/payment-transactions/transaction-add/single',
	name: 'corporateAddSinglePayment',
	meta: {
		title: 'Yeni Kişi Ekle',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/payment/AddSingleTransaction.vue')
},
{
	path: '/home/corporate/auto-attendance/payment-transactions/send-payment-list/:file',
	name: 'corporatePaymentListDetail',
	meta: {
		title: 'Tahsilat Listesi Gönder',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/payment/PaymentList.vue')
},
{
	path: '/home/corporate/auto-attendance/payment-transactions/change-payment-method/:contract',
	name: 'corporateChangePaymentMethod',
	meta: {
		title: 'Ödeme Yöntemini Değiştir',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType, checkContractNo]),
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/home/payment/ChangePaymentMethod.vue')
}
]